<template>
  <div class="relative flex justify-center w-full">
    <div
      v-if="store.currentVariant?.Condition != NEW_CONDITION"
      class="absolute top-[15.6rem] md:top-[20.8rem] left-1/3 z-10"
    >
      <NuxtImg
        v-if="store.currentVariant?.Condition == PERFECT_CONDITION"
        class="w-112 h-112"
        src="/images/product_related/condition_sticker_perfect.svg"
        alt="Begagnad i perfekt skick"
        width="120"
        provider="cloudfront"
      />
      <NuxtImg
        v-if="store.currentVariant?.Condition == GOOD_CONDITION"
        class="w-112 h-112"
        src="/images/product_related/condition_sticker_good.svg"
        alt="Begagnad i bra skick"
        width="120"
        provider="cloudfront"
      />
    </div>

    <div
      v-if="discountImage"
      class="absolute bottom-60 right-0 sm:right-20 md:right-1/4 lg:right-120 z-10"
    >
      <NuxtImg
        :class="[
          discountImage?.OverlayPDPSmall
            ? `w-[${discountImage.OverlayPDPSmall}dvw]`
            : 'w-[30dvw]',
          discountImage?.OverlayPDPMedium
            ? `md:w-[${discountImage.OverlayPDPMedium}dvw]`
            : 'md:w-[10dvw]',
          discountImage?.OverlayPDPLarge
            ? `3xl:w-[${discountImage.OverlayPDPLarge}dvw]`
            : '3xl:w-[5dvw]',
        ]"
        :src="`${discountImage?.ImageUrl}`"
        :alt="discountImage?.ImageAlt"
        format="webp"
        quality="75"
        :provider="
          discountImage?.ImageUrl?.includes('cloudfront')
            ? 'cloudfront'
            : undefined
        "
      />
    </div>

    <ImgSlider :images="store.currentVariant?.Images || []" />
  </div>
</template>

<script lang="ts" setup>
import {
  GOOD_CONDITION,
  NEW_CONDITION,
  PERFECT_CONDITION,
} from '~/models/ListingProduct.api.model';

const store = useMyProductPageStore();

const { discountImage } = useDiscountImage(true);
</script>

<style></style>
